import { CheckoutField } from '@mews-distributor/common';

import { getSortedCountries } from '../../../../modules/globalization/selectors';
import { connectCheckoutField } from '../../utils/connectCheckoutField';

export const inject = connectCheckoutField({
    defaultName: CheckoutField.NationalityCode,
    valueKey: 'selected',
    mapAdditionalProps: (state: $TSFixMe) => ({
        countries: getSortedCountries(state),
    }),
});
